// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/curve_fit_plot_point.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CurveFitPlotSeriesType } from "../../../common/types/v1/curve_fit_plot_series_type_pb";
import { file_quanterix_common_types_v1_curve_fit_plot_series_type } from "../../../common/types/v1/curve_fit_plot_series_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/curve_fit_plot_point.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_point: GenFile = /*@__PURE__*/
  fileDesc("CkJxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3VydmVfZml0X3Bsb3RfcG9pbnQucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSLqAgoRQ3VydmVGaXRQbG90UG9pbnQSDwoCaWQYASABKAlIAIgBARJLCgtzZXJpZXNfdHlwZRgCIAEoDjIxLnF1YW50ZXJpeC5jb21tb24udHlwZXMudjEuQ3VydmVGaXRQbG90U2VyaWVzVHlwZUgBiAEBEhgKC3Nlcmllc19uYW1lGAMgASgJSAKIAQESGgoNY29uY2VudHJhdGlvbhgEIAEoAUgDiAEBEhAKA2FlYhgFIAEoAUgEiAEBEiQKF3BjdF9lcnJvcl9jb25jZW50cmF0aW9uGAYgASgBSAWIAQESGgoNcGN0X2Vycm9yX2FlYhgHIAEoAUgGiAEBQgUKA19pZEIOCgxfc2VyaWVzX3R5cGVCDgoMX3Nlcmllc19uYW1lQhAKDl9jb25jZW50cmF0aW9uQgYKBF9hZWJCGgoYX3BjdF9lcnJvcl9jb25jZW50cmF0aW9uQhAKDl9wY3RfZXJyb3JfYWViYgZwcm90bzM", [file_quanterix_common_types_v1_curve_fit_plot_series_type]);

/**
 * Represents a datapoint in a fitted concentration plot
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotPoint
 */
export type CurveFitPlotPoint = Message<"quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotPoint"> & {
  /**
   * Unique id (UUID) for this point
   *
   * @remarks Typically this will be a `replicate_id` or
   * `replicate_group_id` (replicate group means)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Series type
   *
   * @generated from field: optional quanterix.common.types.v1.CurveFitPlotSeriesType series_type = 2;
   */
  seriesType?: CurveFitPlotSeriesType;

  /**
   * Friendly name of the data series this point belongs to
   *
   * @generated from field: optional string series_name = 3;
   */
  seriesName?: string;

  /**
   * Concentration value (typically the x-coordinate)
   *
   * @generated from field: optional double concentration = 4;
   */
  concentration?: number;

  /**
   * AEB value (typically the y-coordinate)
   *
   * @generated from field: optional double aeb = 5;
   */
  aeb?: number;

  /**
   * Percent error for this concentration value
   *
   * @remarks Applicable to group values (means) only
   *
   * @generated from field: optional double pct_error_concentration = 6;
   */
  pctErrorConcentration?: number;

  /**
   * Percent error for this aeb value
   *
   * @remarks Applicable to group values (means) only
   *
   * @generated from field: optional double pct_error_aeb = 7;
   */
  pctErrorAeb?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotPoint.
 * Use `create(CurveFitPlotPointSchema)` to create a new message.
 */
export const CurveFitPlotPointSchema: GenMessage<CurveFitPlotPoint> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_point, 0);

